/**
 * @fileoverview Generic text matching theme for numbers, letters, or any text labels.
 */

import { ThemeOptions } from '../../services/ThemeService.js';
import { BaseTheme } from './BaseTheme.js';

/**
 * Generic text matching theme with colored circle borders.
 * Used for numbers, letters, or any text-based matching.
 */
export abstract class TextMatchingTheme extends BaseTheme {
    readonly id: string;
    readonly name: string;
    readonly shapeType = 'text';
    readonly matchType = 'label';
    
    /**
     * Create a text matching theme.
     * @param id - Unique theme identifier
     * @param name - Display name
     * @param labels - Array of labels to display (numbers, letters, emojis, etc.)
     * @param withCircleBorder - Whether to show colored circle border (default: true)
     * @param options - Theme configuration options
     */
    constructor(id: string, name: string, labels: Array<string | number>, options: ThemeOptions = {}) {
        const defaultOptions: ThemeOptions = {
            numPairs: 5,
            isPremium: false,
            hasMovement: false,
        };
        super({...defaultOptions, labels: labels, ...options });
        
        this.id = id;
        this.name = name;
    }
}
